import * as React from 'react';

import { cn, Switch } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import { $inventoryAvailabilityVisible } from '../../_state/inventoryAvailability.state';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

export const InventoryAvailabilitySwitch = () => {
  const t = useTranslations();
  const [isVisible, setIsVisible] = useAtom($inventoryAvailabilityVisible);

  return (
    <div
      className={cn(
        '@InventoryAvailabilitySwitch',
        'rounded-md border border-neutral/10 bg-neutral/5 px-3 py-2',
      )}
    >
      <Switch
        isSelected={isVisible}
        onChange={setIsVisible}
        className="flex items-center gap-2"
      >
        <span>{t.itemTable.inventoryAvailability.switch}</span>
      </Switch>
    </div>
  );
};
